import { createContext } from 'react';

const AuthorContext = createContext(null);

export default AuthorContext;
